import { render, staticRenderFns } from "./OfficePowerPointIcon.vue?vue&type=template&id=4716ef4f"
import script from "./OfficePowerPointIcon.vue?vue&type=script&lang=js"
export * from "./OfficePowerPointIcon.vue?vue&type=script&lang=js"
import style0 from "./OfficePowerPointIcon.vue?vue&type=style&index=0&id=4716ef4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports